import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'clearing-cash-balances',
        label: 'Core',
        to: '/clearing/operations/balance',
      }),
    }) satisfies AggregateBreadcrumb,
});
